<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.contactListViewModal.title' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <div class="mt-3">
        @if (contacts?.length > 0) {
          <div class="card-body table-responsive">
            <table class="table table-hover table-centered">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'shared.contactListViewModal.name' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'shared.contactListViewModal.phone' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of contacts; track $index) {
                <tr>
                  <td class="text-primary-emphasis">{{ item.name | truncate: 50 }}</td>
                  <td class="text-primary-emphasis">{{ item.phone }}</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        }

        @if (contacts?.length == 0) {
          <empty-records-legacy-component
            [message]="'shared.contactListViewModal.emptyMessage' | translate"
            [subMessage]="'shared.contactListViewModal.emptySubMessage' | translate">
          </empty-records-legacy-component>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'shared.contactListViewModal.close' | translate }}
      </button>
    </div>
  </div>
</div>
